"use client";
import { useState, type FormEvent } from "react";
import { Button } from "./ui/Button";
export function PrivacyRequestForm() {
  const [email, setEmail] = useState("");
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const submit = async (event: FormEvent) => {
    event.preventDefault(); setSaving(true); setError(""); setMessage("");
    try {
      const response = await fetch("/api/account/delete-data", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email }) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Could not record your request. Please email privacy@curatedden.com.");
      setMessage(data.message); setEmail("");
    } catch (err) { setError(err instanceof Error ? err.message : "Could not record your request. Please email privacy@curatedden.com."); }
    finally { setSaving(false); }
  };
  return <form onSubmit={submit} className="rounded-xl border border-line bg-paper-deep p-5 mt-4">
    <label htmlFor="privacy-request-email" className="block font-semibold text-ink">Request deletion of your data</label>
    <p className="text-xs mt-1">We record the request for review and may need to verify your identity. Submitting this form does not immediately delete records.</p>
    <div className="flex flex-col sm:flex-row gap-3 mt-4">
      <input id="privacy-request-email" type="email" required maxLength={254} autoComplete="email" value={email} onChange={event => setEmail(event.target.value)} placeholder="Your email address" className="min-w-0 flex-1 border border-line rounded-xl bg-paper px-3 py-2 text-base" />
      <Button type="submit" disabled={saving}>{saving ? "Recording…" : "Request deletion"}</Button>
    </div>
    {message && <p role="status" className="text-sm mt-3">{message}</p>}
    {error && <p role="alert" className="text-sm text-red-700 mt-3">{error}</p>}
  </form>;
}
